import { ChevronDown, ChevronUp } from 'lucide-react';
import React, { useState } from 'react';

import { cn } from '@/lib/utils';

export interface CollapsibleListProps {
  items: React.ReactNode[];
  showLabel?: string;
  hideLabel?: string;
  defaultExpanded?: boolean;
  className?: string;
}

export const CollapsibleList: React.FC<CollapsibleListProps> = ({
  items,
  showLabel = 'Show List',
  hideLabel = 'Hide List',
  defaultExpanded = false,
  className,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className={cn('mt-2', className)}>
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-800"
      >
        {isExpanded ? (
          <>
            <ChevronUp className="h-4 w-4" />
            {hideLabel}
          </>
        ) : (
          <>
            <ChevronDown className="h-4 w-4" />
            {showLabel}
          </>
        )}
      </button>
      {isExpanded && (
        <ul className="mt-2 space-y-1 text-sm text-gray-600">
          {items.map((item, index) => (
            <li key={index} className="flex items-start gap-2">
              <span className="mt-1.5 h-1 w-1 flex-shrink-0 rounded-full bg-gray-400" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
